export default __webpack_public_path__ + "static/media/fourth-section-bg-dkt.3c360646.png";